import React, { useState, useEffect, useRef } from "react";
// import AboutImage from '../../../assests/images/josurneyt.png';
import ServicesSection from "./servicesData";
import Technologies from "./techCategory";
import Countact_us from '../../mainSection/aboutPage/requestQuote';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Helmet } from 'react-helmet'
import one from '../../../assests/icon/Pasted image (4).png'
import two from '../../../assests/icon/Pasted image (5).png'
import three from '../../../assests/icon/img-1.png'
import four from '../../../assests/icon/Pasted image (3).png'
import five from '../../../assests/icon/Pasted image (2).png'
import six from '../../../assests/icon/icon1.png';
import AboutImage from '../../../assests/service.png'
import bgimage from '../../../assests/webiconF (3)/2.png'

const cards = [
  {
    title: "Round The Clock Availability",
    description:
      "Need tech talent anytime? We’ve got you covered! Our experts are available round the clock to ensure seamless project execution.",
    background: six,
  },
  {
    title: "Highly qualified team",
    description:
      "Power up your projects with our Highly Qualified & Dedicated Team! Expert developers, seamless execution. Hire the best, achieve brilliance!",
    background: two,
  },
  {
    title: "SLA 4 Hours",
    description:
      "Swift Support, Guaranteed! With an SLA of just 4 hours, we ensure rapid issue resolution and uninterrupted workflow. Your success, our priority!",
    background: one,
  },
  {
    title: "Transparent Communication",
    description:
      "Transparent Communication, Every Step of the Way! No hidden surprises—just clear, honest, and real-time updates to keep your projects on track.",
    background: four,
  },
  {
    title: "Remote Onboarding & Support",
    description:
      "No geographical limitations when it comes to talent.",
    background: five,
  },
  {
    title: "Continuous Evaluation",
    description:
      "We constantly monitor the quality of work being provided.",
    background: three,
  },

];

const Staffing = () => {
  const sectionRef = useRef(null);
  const formRef = useRef(null);  // <-- Add this line for the form scroll
  const [isVisible, setIsVisible] = useState(false);
  const [bgPositionY, setBgPositionY] = useState(5.69531);
  const [selectedTech, setSelectedTech] = useState("");

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        const { isIntersecting, boundingClientRect } = entry;
        const isEnteringFromBottom = isIntersecting && boundingClientRect.top > 0;

        setIsVisible(isEnteringFromBottom);
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const newPositionY = 5.69531 - scrollY * 0.5;
      setBgPositionY(newPositionY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Custom handler for selecting technology and scrolling to form
  const handleTechSelect = (tech) => {
    setSelectedTech(tech);
    setTimeout(() => {
      if (formRef.current) {
        formRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100); // Give React time to update
  };

  const features = [
    {
      title: 'Cost Optimization',
      text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s.',
      img: 'https://tekitnewlogo.zohosites.in/images/Mask%20Group%204%20-1-.png',
      imgWidth: 180,
      imgHeight: 180,
    },
    {
      title: 'Time Saving Recruitment',
      text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s.',
      img: 'https://tekitnewlogo.zohosites.in/images/Group 114.png',
      imgWidth: 140,
      imgHeight: 180,
    },
    {
      title: 'Improve Productivity',
      text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s.',
      img: 'https://tekitnewlogo.zohosites.in/images/Mask Group 4.png',
      imgWidth: 130,
      imgHeight: 185,
    },
    {
      title: 'Availability of Skilled resources',
      text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s.',
      img: 'https://tekitnewlogo.zohosites.in/images/Group 300.png',
      imgWidth: 130,
      imgHeight: 154,
    },
  ];

  return (
    <div className="z-10 pt-2">
      <Helmet>
        <title>Top Staffing Solutions for IT Talent | Flexible & Scalable Workforce </title>
        <meta name="description" content="Streamline your hiring with our staffing solution process. We source, vet, and match top talent to meet your business needs quickly and efficiently." />
        <meta name="keywords" content="Top IT Staff Augmentation Companies, IT Staffing Services, Largest IT Staffing Companies, Staffing IT, Contract IT Staffing, Staffing IT Services, IT Staffing, Staffing Solutions, IT Staffing Solutions, Premier Staffing Solutions, IT Services, Executive Staffing, Staffing Company, staffing services" />
      </Helmet>
      <section
        ref={sectionRef}
        className="py-16 pt-40 bg-[#f4f5f6] bg-cover bg-center bg-no-repeat "
        style={{ backgroundImage: `url(${AboutImage})` }}
      >
        <div className="absolute inset-0 "></div>
        <div className="container mx-auto h-full flex items-center justify-center text-center">
          <div className="flex flex-col items-center">
            <img src={bgimage} className="w-20" />
            <p className="text-black font-bold 2xl:text-[40px] lg:text-[32px] text-[45px]">
              Hire Expert Developers
            </p>
            <p className="text-black 2xl:text-[35px] lg:text-[28px] text-[40px]">
              to Power Your Projects - Affordable, Scalable, and Skilled
            </p>
          </div>
        </div>
      </section>
      <section className="w-full py-12 px-4 lg:px-8   place-items-center">
        <h1 className="text-black text-[52px] 2xl:text-[40px] lg:text-[32px]">What Makes TekIT Different ?</h1>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 px-10 text-center mt-6" >
          {cards.map((card, index) => (
            <div
              key={index}
              className="relative rounded-xl overflow-hidden shadow-[0_8px_30px_rgba(0,0,0,0.25)] group lg:hover:scale-105 transition-transform duration-300 bg-gray-900"
            >
              <div className="flex justify-center items-center">
                <img
                  src={card.background}
                  alt={card.title}
                  className="w-20 h-full py-6 object-contain "
                />
              </div>
              <div className="px-6 pb-4  flex flex-col gap-3">
                <h4 className="text-white font-semibold text-[40px] lg:text-[20px] 2xl:text-[24px]">
                  {card.title}
                </h4>
                <p className="text-white/80 lg:text-[16px] 2xl:text-[18px] text-[36px]">
                  {card.description}
                </p>
              </div>
            </div>
          ))}
        </div>
        {/* <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 w-[80%] mt-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-[#00A9E6] rounded-lg p-6 flex gap-4 items-start"
            >
              <img
                src={feature.img}
                alt={feature.title}
                data-aos="fade-up"
                width={feature.imgWidth}
                height={feature.imgHeight}
                className="object-contain"
              />
              <div>
                <h3 data-aos="fade-up" className="text-white text-[32px] 2xl:text-[26px] lg:text-[20px] font-semibold mb-2 font-recoleta">{feature.title}</h3>
                <p data-aos="fade-up" className="text-white text-[24px] 2xl:text-[20px] lg:text-[16px] leading-8 font-recoleta ">{feature.text}</p>
              </div>
            </div>
          ))}
        </div> */}
      </section>
      <section>
        <ServicesSection />
        {/* Pass custom handler to Technologies */}
        <Technologies onSelectTech={handleTechSelect} />
        {/* Wrap form in a ref for scrolling */}
        <div ref={formRef}>
          <Countact_us selectedTech={selectedTech} />
        </div>
      </section>
    </div>
  )
}

export default Staffing;
